import { patchRoute } from 'utils/patch-route';
import { SHOP_PATH } from 'common/constants';

export function patchPathname(path = '') {
  if (path.includes(SHOP_PATH)) {
    return SHOP_PATH;
  }

  return patchRoute(path);
}
